import React from "react";
import { BodyText } from "../BodyText";
import { useUtilityStyles } from "../hooks/useUtilityStyles";
import { THEME } from "../theming/theming";
import { classNames } from "../utils/classNames";
export var Prompt = function (_a) {
    var message = _a.message, _b = _a.type, type = _b === void 0 ? "warning" : _b, className = _a.className, styleOptions = _a.styleOptions, role = _a.role, hideMessage = _a.hideMessage;
    var glyph = "exclamationSign";
    var color = THEME.palette.warning.base.color;
    if (type === "success") {
        glyph = "circleCheck";
        color = THEME.palette.success.base.color;
    }
    if (type === "error") {
        glyph = "circleAlert";
        color = THEME.palette.error.base.color;
    }
    if (type === "locked") {
        glyph = "lock";
        color = THEME.palette.gray.slate.color;
    }
    if (type === "info") {
        glyph = "infoSign";
        color = THEME.palette.primary.base.color;
    }
    var utilityStyles = useUtilityStyles(styleOptions);
    return (React.createElement(BodyText, { className: classNames("prompt", className !== null && className !== void 0 ? className : "", utilityStyles.utilities), glyph: glyph, glyphColor: color, message: message, textStyle: { bold: true }, role: role !== null && role !== void 0 ? role : undefined, hideMessage: hideMessage }));
};
